export default {
  'primary': '#140A9A',
  'secondary': '#00a7e1',
  'accent': '#140A9A'
}
